<template>
  <div>
    <img
      v-if="isOn"
      height="30"
      :src='getImgOn()'
    />
    <img
      v-else
      height="30"
      :src='getImgOff()'
    />
  </div>
</template>

<script>

const lightBulbOff = require('../assets/img/lightBulbOff.png');
const lightBulbOn = require('../assets/img/lightBulbOn.png');

export default {
  name: 'LightBulb',
  props: {
    isOn: Boolean,
  },
  data() {
    return {};
  },
  methods: {
    getImgOff() {
      return lightBulbOff;
    },
    getImgOn() {
      return lightBulbOn;
    },
  },
};
</script>
